module.exports = __webpack_public_path__ + "img/2.31b902a.webp";